<div class="privacy-main">
  <div class="col-lg-12 row">
    <div class="col-lg-1"></div>
    <div class="col-lg-10">
      <h2 class="text-center heading-main p-3">Privacy Policy</h2>
      <h3 class="heading-sub p-3">Policy on Privacy and Security of Information</h3>
      <div class="risk-data">
        <div class="risk-content ">
          <p>
            <br> We, at ITI Mutual Fund, respect investors right to privacy.
          </p>
          <p>
            We recognise that the lawful and correct treatment of personal data is very important to maintain investor's
            confidence in ourselves.
          </p>
          <p>
            It is our endeavor to ensure that any personal data that we collect, process, record or use in any way
            whether it is held on paper, on computer or other electronic media will have appropriate safeguards in place
            to comply with our obligations of confidentiality and privacy.

          </p>
          <p>
            In this regard, we request investors to kindly read this “Policy on Privacy and Security of Information”
            carefully.
          </p>
          <p>
            The terms as may be used in this document would be in accordance with “The Information Technology Act 2000
            as amended till date, Information Technology (Reasonable security practices and procedures and sensitive
            personal data or information) Rules, 2011” and such other rules/regulations and Circulars as may be
            applicable.
          </p>
          <h3 class="heading-sub2  pt-3 pl-3">
            Interpretation
          </h3>
          <div class="risk-data li-data">
            <ul>
              <li>All references to the masculine shall include the feminine and all references, to the singular shall
                include the plural and vice-versa. All references to investor whether masculine or feminine include
                references to non-individuals also unless repugnant to the context thereof;
              </li>
              <li>Any reference to any statute or statutory provision shall be construed as including a reference to any
                statutory modifications or re-enactment therein from time to time;
              </li>
              <li>
                Headings are for ease of reference only.
              </li>
            </ul>
          </div>
          <h3 class="heading-sub2  pt-3 pl-3">
            The Policy
          </h3>
          <div class="risk-data">
            <p>
              ITI Asset Management Limited (‘AMC’), a Company incorporated under the Companies Act, 1956, has been
              appointed as the Investment Manager to the Schemes of ITI Mutual Fund. ITI Mutual Fund Trustee Private
              Limited (‘Trustee Company’) is the Trustee to the Mutual Fund. The Investment Trust of India Limited and
              ITI Credit Limited are the Sponsors of the Mutual Fund.
            </p>
            <p>
              The AMC either directly or through third party service providers engaged by the AMC (Service Providers)
              such as the Registrar and Transfer agents collects, receives, possesses, stores, deals or handles
              information received from investors whether existing or prospective.
            </p>
            <p>
              Such information can be personal and sensitive in nature as per the indicative list given below:
            </p>
            <div class="li-data2">
              <ul>
                <li>
                  Bank Account details change of bank account details or registration of multiple bank accounts etc.
                  through
                  application forms;

                </li>
                <li>
                  Payment instrument details at the time of submitting application at the time of investment or as proof
                  for
                  carrying out change of bank account or any other details of debit card obtained (if any);
                </li>
                <li>
                  Generation and storing password (PIN) in encrypted form based on the request from the investor under
                  the
                  online mode of investments;

                </li>
                <li>
                  Biometric information obtained, if any;

                </li>
                <li>
                  Demat Account details like beneficiary account no. etc.;

                </li>
                <li>
                  Annual Income and savings profile; and

                </li>
                <li>
                  Other information as may be considered as sensitive and personal.

                </li>
              </ul>
            </div>
            <br>
            <p>
              The aforesaid information is being collected by the AMC/Service Providers to respond to your requests, to
              process the investment applications and to also ensure safe subscriptions/redemptions through points of
              acceptance in physical form, website, online portals, Automated Teller Machines and such other mode. The
              AMC may also call the investors to inform them with respect to the other products or services offered by
              the AMC. The said information is also being collected to be compliant with the Know Your Client (KYC)
              norms under the Prevention of Money Laundering Act, 2002, (PMLA), the rules issued there under, and
              guidelines and circular on Anti- Money Laundering issued by SEBI and SEBI (Mutual Funds) Regulations, 1996
              as amended till date.


            </p>
            <p>
              The aforesaid information is the basis of our ability to provide investors with good, qualitative, timely
              and efficient service, while also keeping the information and data provided totally secure and
              confidential.


            </p>
            <p>
              We endeavor to have suitable technical, operational and physical security controls and measures to protect
              investors personal/sensitive data or information that are commensurate with the nature of our business at
              all times.


            </p>
            <p>
              We permit only authorized employees who are trained in the proper handling of investor information, to
              have access to aforesaid information. We would ensure to enter into suitable terms with third party
              service providers in order to protect investor confidentiality and follow a non-disclosure or restricted
              disclosure policy. Further, the employees who violate the privacy and confidentiality promise shall be
              subjected to disciplinary action.


            </p>
            <p>
              We shall reveal only such information to external authorities as may be found relevant and necessary in
              order to comply with the applicable laws of the land and to third party service providers to ensure smooth
              functioning of the activities as may be prescribed under applicable laws like Registrar and Transfer
              Agents/distributors/banks/sub-brokers/call-centers/custodians/depositories and such other
              entities/persons. By using our website or by agreeing to transact with us, you agree to the above sharing
              of information during your relationship with us. We may also be required from time to time to disclose
              investor personal information to governmental or judicial bodies or agencies or our regulators based on
              their requirement to comply with the applicable laws including cyber laws. In addition to the above we may
              also use the information shared by investors to contact investors regarding the products and services
              offered by us and seek feedback on the services provided. Further, such information may also be used by us
              to generate statistics and reports and/or to protect and defend the rights, interest and property of the
              Mutual Fund, AMC, Trustee Company, Sponsors & its affiliates and directors and/or to enforce legal rights
              or provisions of the Scheme related Documents of the Mutual Fund viz. Scheme Information Document (SID),
              Statement of Additional Information (SAI) and Key Information Memorandum (KIM). Further, it may be noted
              that Internet Protocol (IP) addresses, browser supplied information and site session information may be
              recorded as part of the normal operations and for security monitoring purposes.


            </p>
            <p>
              Nevertheless, it is our foremost endeavor to ensure that the Investor’s Privacy is protected at all points
              in time. The investors (whether existing/prospective) must ensure to recheck the information or data being
              provided to the AMC or any person acting on its behalf. Incase if any of the data/information is found to
              be inaccurate or incorrect, the same shall be informed to the AMC for immediate amendment. The AMC and any
              person acting on its behalf shall not be responsible for the authenticity of the personal information or
              sensitive personal data or information supplied by the investors (whether existing/prospective).


            </p>
            <p>
              Our website may use cookies. By using our website and agreeing to these terms of use, you consent to our
              use of cookies in accordance with the terms of our privacy policy.


            </p>
            <p>
              Investors shall not be covered by the terms of this Policy if they access other websites using links from
              this website.


            </p>
            <p>
              Further, despite our efforts to protect investors privacy, if unauthorized persons breach security control
              measures and illegally use such sensitive/personal data or information, the Mutual Fund, AMC, Trustee
              Company, Sponsors and its affiliates and directors shall not be held responsible/liable.


            </p>
          </div>
          <h3 class="heading-sub2  pt-3 pl-3">
            Amendments/Modifications

          </h3>
          <div class="risk-data">
            <p>This Privacy Policy available on our website is current and valid. However, the AMC reserves the right to
              amend/modify any of the sections of this policy at any time and the investors are requested to keep
              themselves updated for changes by reading the same from time to time.

            </p>
          </div>
          <h3 class="heading-sub2  pt-3 pl-3">
            Retention of information/data


          </h3>
          <div class="risk-data">
            <p>It may be noted that we may retain the data as may be provided by the investors till such time as may be
              provided under the law and as required to efficiently provide service to the investors.


            </p>
          </div>
          <h3 class="heading-sub2  pt-3 pl-3">
            Grievance redressal


          </h3>
          <div class="risk-data">
            <p>If investors have any concerns relating to their personal and sensitive information they may be addressed
              to Ms. Nimisha Keny, Investor Relation Officer, Contact No. 022 69153500, Email Id –
              <a href="mailto:mfassist@itiorg.com">mfassist&#64;itiorg.com</a>. For more details please refer to the
              Scheme related documents available
              on our website viz. <a href="www.itiamc.com" target="_blank">www.itiamc.com</a>.


            </p>
            <p><i>Investors shall have expressly consented to the terms of this Policy if they enter and use this
                website or provide any information while transacting with us.

              </i></p>
          </div>

        </div>
      </div>
    </div>



    <div class="col-lg-1"></div>
  </div>
</div>